export const firebaseConfig = require("../sa").config;
export const api = process.env.VUE_APP_API;
export const serviceSchedulerURL = process.env.VUE_APP_SERVICE_SCHEDULER_URL;
export const maydayURL = process.env.VUE_APP_MAYDAY_URL;